import React, { useState } from "react";
import { Skeleton } from "../../../../../../../shared/Skeleton/Skeleton";
import { Empty } from "../../../../../../../shared/Empty/Empty";
import { Box } from "../../../../../../../shared/Box/Box";
import { Table } from "../../../../../../../shared/Table/Table";
import { apiDateFormat } from "../../../../../../../Utils";
import { useVerticalsReportDetails } from "./hooks/useVerticalsReportDetails";
import Header from "./components/Header/Header";
import { ORDER_TYPES } from "../../../../../../../consts/api";
import { SortAdornment } from "../../../../../../../shared/SortAdornment/SortAdornment";
import { useExportVerticalsReportDetails } from "./hooks/useExportVerticalsReportDetails";
import { uiNotification } from "../../../../../../../services/UINotificationService";
import { composeDownloadDataUrl } from "../../../../../../../utilities/api";

const VerticalsReportDetails = ({
  selectedRowView,
  setSelectedRowView,
  period,
}) => {
  const [order, setOrder] = useState({
    by: "patient",
    direction: "asc",
  });

  const params = {
    vertical_id: selectedRowView.id,
    start_date: apiDateFormat(period.value.from),
    end_date: apiDateFormat(period.value.to),
    sortBy: order.by,
    order: order.direction,
  };

  const { data, isLoading } = useVerticalsReportDetails(params);
  const { mutate: downloadExcel, isLoading: isDownloading } =
    useExportVerticalsReportDetails();

  const handleDownload = () => {
    downloadExcel(params, {
      onSuccess: (res) =>
        window.open(composeDownloadDataUrl(res.data.data.file), "_blank"),
      onError: (err) =>
        uiNotification.error(
          err?.response?.data?.message ||
            "An error occurred while downloading the report.",
        ),
    });
  };

  const updateOrder = (orderFieldKey) => {
    setOrder({
      by: orderFieldKey,
      direction:
        order.direction === ORDER_TYPES.desc
          ? ORDER_TYPES.asc
          : ORDER_TYPES.desc,
    });
  };

  const renderSortWrap = (children, field) => (
    <SortAdornment
      value={order.by === field ? order.direction : undefined}
      onToggle={() => updateOrder(field)}
    >
      {children}
    </SortAdornment>
  );

  const reportHeader = [
    {
      data: renderSortWrap("Patient", "patient"),
      accessor: "patient",
    },
    {
      data: renderSortWrap("Appointment Count", "appointment_count"),
      accessor: "appointment_count",
    },
    {
      data: renderSortWrap("Total Spent", "total_spend"),
      accessor: "total_spend",
    },
  ];

  const tableDataEmpty = !isLoading && !data.length;

  return (
    <>
      <Header
        title="Verticals Usage"
        withBackBtn
        backFunc={() => setSelectedRowView(null)}
        download={{
          initiate: handleDownload,
          isLoading: isDownloading,
        }}
      />
      <div>
        <div>
          <Box>
            <h4 className="m-t-15 m-b-20">{selectedRowView.name}</h4>
            <Table bgColor="white" cols={reportHeader} data={data} />
            {isLoading && (
              <Skeleton count={8} height={40.5} borderRadius="0px" />
            )}
            {tableDataEmpty && <Empty position="center" />}
          </Box>
        </div>
      </div>
    </>
  );
};

export default VerticalsReportDetails;
